import { render } from "./CoachesList.vue?vue&type=template&id=19ac2f9c&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=19ac2f9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19ac2f9c"

export default script